import { useEffect, useState } from 'react';
import Alert from '../../../../shared/components/Alert/Alert';
import Button from '../../../../shared/components/Button/Button';
import { createExpenseExcel, downloadExpenseExcel } from './expenses.api';

export default function ExpenseExcelExport({ claim, disabled, onBusy, onArchived }) {
  const [archive, setArchive] = useState(claim.latestExcelExport || null); const [error, setError] = useState(''); const [busy, setBusy] = useState(false);
  useEffect(() => { setArchive(claim.latestExcelExport || null); setError(''); }, [claim.id, claim.revision, claim.latestExcelExport]);
  const exportExcel = async () => {
    setBusy(true); onBusy(true); setError('');
    try { const result = await createExpenseExcel(claim); setArchive(result); onArchived(result); await downloadExpenseExcel(claim.id, result); }
    catch (e) { setError(e.message); }
    finally { setBusy(false); onBusy(false); }
  };
  return <section aria-label="Export Excel" className="expense-excel-export">
    <p>Le classeur reprend les montants validés. Il est classé dans la GED avec les justificatifs, dans Notes de frais / {claim.period.slice(5)}.{claim.period.slice(0, 4)}.</p>
    {archive && <p role="status">Excel enregistré dans la GED le {new Intl.DateTimeFormat('fr-FR', { dateStyle: 'short', timeStyle: 'short' }).format(new Date(archive.createdAt))}.</p>}
    {error && <Alert severity="error">{error}</Alert>}
    <Button disabled={disabled} loading={busy} onClick={exportExcel}>{archive ? 'Télécharger l’Excel' : 'Exporter en Excel'}</Button>
    <p className="expense-note">L’export ne marque pas la note comme transmise au cabinet ou remboursée. Conservez le classeur et ses justificatifs dans le même dossier pour ouvrir les pièces depuis Excel.</p>
  </section>;
}
